import { supabase } from '../utils/supabaseClient';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export async function analyzeDream(query) {
    try {
        const { data: { session } } = await supabase.auth.getSession();
        const token = session?.access_token;

        const response = await fetch(`${API_URL}/dream/analyze`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { 'Authorization': `Bearer ${token}` } : {})
            },
            body: JSON.stringify({ query }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.detail || 'Failed to analyze dream');
        }

        return await response.json();
    } catch (error) {
        console.error('Dream analysis error:', error);
        throw error;
    }
}
